<template>
	<section class='banner-wrapper' :class="[orderNum > 0? 'progress-dialog-margin' : '']">
		<div class='banner-bgimg'></div>
    <!-- 'width:'+getBannerStyle.width + 'px; height:'+getBannerStyle.height+'px' -->
		<mt-swipe :continuous="true" class="index-banner" :class="{'full':full}" v-bind:style="'width: 100vw; height: 404px'" :showIndicators="isShowIndicators">
		  <mt-swipe-item v-for="(item, index) in items" :key="index">
		    <div class="banner-list"><img class="banner-image" v-lazy="item.adv_code" v-if='item.adv_code' @click="goAdUrl(item)"></div>
		  </mt-swipe-item>
		</mt-swipe>
	</section>

</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'IndexBanner',
  data () {
    return {
    }
  },
  props: ['items','full'],
  computed: {
    ...mapState({
      orderNum: (state) => state.member.orderNum,
    }),
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      let itemHeight = width * (300 / 702)
      return {
        width: itemWidth,
        height: itemHeight
      }
    },
    isShowIndicators () {
      if (this.items && this.items.length > 1) {
        return true
      }
      return false
    }
  },
  methods: {
    goAdUrl (item) {
      switch (item.adv_type) {
        case 'goods':
          this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.adv_typedate } })
          break
        case 'store':
          this.$router.push({ name: 'HomeStoredetail', query: { id: item.adv_typedate } })
          break
        case 'article':
          this.$router.push({ name: 'HomeArticledetail', query: { article_id: item.adv_typedate } })
          break
        case 'url':
          window.location.href=item.adv_typedate
          break
      }
    }
  }
}
</script>

<style lang="scss">
  .index-banner{
    height: 404px;
    .mint-swipe-indicators{
      top: 15.7rem;
      .mint-swipe-indicator{opacity: 1;background: #D8D8D8;
        &.is-active{
          // background: $primaryColor
          background: #F4D525 !important;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
.banner-wrapper{
  // position: relative;
  position: absolute;
  background: #fff;
  z-index: 1;
  top: 0px;
  width: 100vw;
}
.banner-wrapper .banner-bgimg{
  position: absolute;
  z-index: 1;
  // background: #f4c41e;
  width: 100%;
  height: 6rem;
  border-radius: 0 0 .8rem .8rem;
}
.banner-wrapper .index-banner{
  // padding-top:$modelSpace;
  // padding-bottom:1.5rem;
  z-index: 2;
  height: 404px;
}
.banner-wrapper .index-banner .banner-list{
  position:absolute;
  top:0;
  bottom:0;
  // left:$pageSpace;
  // right:$pageSpace;
  width: 100%;
}
.banner-wrapper .index-banner .banner-list .banner-image{width:100%;height:100%;border-radius: 0 0 .4rem .4rem;}

  .index-banner.full{padding-top:0;
    .banner-list{left:0;right:0;
      .banner-image{border-radius:0}
    }
  }
</style>
